import { Injectable } from '@angular/core';
import { ServiceConfig } from 'app/_services/service-config';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class BrandReportService {
    private host = ServiceConfig.host;
    private BASE_URL = this.host + '/api/brand-manage';
    private url_report = this.host + '/api/ipcc/';
    private url_report_manage = this.host + '/api/report-manager/';
    private httpHeaders = new HttpHeaders({
        'Content-Type': 'application/json'
    });
    private httpParams = new HttpParams().set('token', JSON.parse(localStorage.getItem('currentSmmData')).token);

    constructor(private httpClient: HttpClient) {
    }

    getAll(): Observable<any> {
        return this.httpClient.post(`${this.BASE_URL}/getActive`, {}, { params: this.httpParams, headers: this.httpHeaders });
    }


    create(newBrand): Observable<any> {
        let data = JSON.parse(localStorage.getItem('currentSmmData'));
        let url = this.BASE_URL + '/create?token=' + data.token;
        return this.httpClient.post<any>(url, newBrand);
    }

    update(brandItem): Observable<any> {
        return this.httpClient.post(`${this.BASE_URL}/update`, brandItem, { params: this.httpParams, headers: this.httpHeaders });
    }
    updateMainBrand(brandItem): Observable<any> {
        return this.httpClient.post(`${this.BASE_URL}/updateMainBrand`, brandItem, { params: this.httpParams, headers: this.httpHeaders });
    }

    delete(id): Observable<any> {
        return this.httpClient.get(this.BASE_URL + `/delete/${id}`, { params: this.httpParams, headers: this.httpHeaders });
    }

    getReport(body): Observable<any> {
        return this.httpClient.post(`${this.url_report}/report/brandReportChart`, body, { params: this.httpParams, headers: this.httpHeaders });
    }

    createReportManager(config): Observable<any> {
        let data = JSON.parse(localStorage.getItem('currentSmmData'));
        let url = this.url_report_manage + 'create?token=' + data.token;
        return this.httpClient.post<any>(url, config);
        // return this.httpClient.post(`${this.BASE_URL}/create`, newBrand, { params: this.httpParams, headers: this.httpHeaders });
    }
    getAllReportManager(body): Observable<any> {
        return this.httpClient.post(`${this.url_report_manage}/getList`, body, { params: this.httpParams, headers: this.httpHeaders });
    }
    deleteReport(id): Observable<any> {
        return this.httpClient.get(this.url_report_manage + `/delete/${id}`, { params: this.httpParams, headers: this.httpHeaders });
    }

}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/brand-report/brand-reports.service.ts